export const LISTE_FORMAT_AFFICHE = {
  title: 'Liste des formats d\'affiches',
  breadcrumb: {
    liste: 'Liste format  d\'affiche',
  },
  actions: {
    add: 'Ajouter un format  d\'affiche',
  },
  tab: {
    code: 'Code',
    libelle: 'Libellé',
    largeur: 'Largeur (mm)',
    longueur: 'Hauteur (mm)',
    typeMateriel: 'Type matériel',
    natureSupportAffiche: 'Nature support  d\'affiche',
  },
  filtres: {
    codes: 'Code(s)',
    libelle: 'Libellé',
    natureSupport: 'Nature(s) support d\'affiche',
    materielType: 'Type(s) de matériel',
    hauteurs: 'Hauteur(s)',
    largeurs: 'Largeur(s)',
  },
};

export const EDITION_FORMAT_AFFICHE = {
  titleEdit: 'Modifier le format  d\'affiche {libelle}',
  titleAdd: 'Ajouter un format  d\'affiche',
  breadcrumb: {
    liste: 'Liste format  d\'affiche',
  },
  fields: {
    code: 'Code',
    libelle: 'Libellé',
    largeur: 'Largeur (mm)',
    longueur: 'Hauteur (mm)',
    typeMateriel: 'Type matériel',
    natureSupportAffiche: 'Nature support  d\'affiche',
    visuel: 'Visuel',
    impression: 'Impression',
    faconnage: 'Façonnage',
    expedition: 'Expédition',
  },
  success: {
    add: 'Format  d\'affiche ajouté avec succès',
    edit: 'Format  d\'affiche modifié avec succès',
  },
  informationGeneral: 'Informations générales',
  etapeInformation: {
    title: 'Etape d\'information',
    prestation: 'Prestation',
    livraison: 'A livré à',
    fairePar: 'A faire par',
    advancedSearchFournisseur: 'Recherche avancée de fournisseur',
    advancedSearchLieuDeLivraison: 'Recherche avancée de lieu de livraison',
    msgErrorSelection: 'Votre sélection est différente de la sélection sur le format affiche standard',
    annonceurCommande: 'Annonceur de la commande',
  },
  etapeInformationDetail: {
    prestation: 'Prestation :',
    livraison: 'A livré à :',
    fairePar: 'A faire par :',
  },
  errors: {
    hasBoolAnnonceurAndFournisseur: '"A faire par" ne peut pas avoir de fournisseur si l\'annonceur de la commande est actif',
  },
};

export const DETAIL_FORMAT_AFFICHE = {
  title: 'Détail format  d\'affiche {libelle}',
  breadcrumb: {
    liste: 'Liste format  d\'affiche',
  },
};
